import React, { useState } from 'react';
import { string, arrayOf, object, bool, number } from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import HrbTranslate from '../../../components/language/HrbTranslate';
import FilingStatusRow from './FilingStatusRow';
import FilingStatusSummary from './FilingStatusSummary';
import ReturnStatusIcon from './ReturnStatusIcon';
import Skeleton from '../../../components/library/loaders/Skeleton';
import CollapsibleCardHeader from '../../../components/library/stacking-collapsible-cards/CollapsibleCardHeader';
import { useSelector, useDispatch } from 'react-redux';
import ProductActions from '../../../store/productRedux'
import useFilingStatus from '../hooks/useFilingStatusHook';
import { Fragment } from 'react';
import ReturnStatusLabel from './ReturnStatusLabel';

const FilingStatusCard = props => {

    const { filer, clientName, hideJsonButtons, returnStatii, isRefile, refileIndex, isCollapsed } = props

    const { dashboardStatus, netfileStatus, CRAStatus, RQStatus, T1135Status, groupedStatii } = useFilingStatus(returnStatii, filer)

    const { taxYear } = useRouteMatch().params
    const [collapsed, setCollapsed] = useState(isCollapsed)
    const dispatch = useDispatch()
    const lang = useSelector(state => state.layout.lang)

    const onCopyJsonClick = r => {
        dispatch(ProductActions.getFiledReturn(taxYear, r.fileId, r.fileSource))
    }

    const renderStatiiFor = (submissionType) => {
        let statii = groupedStatii[submissionType] || []
        if (statii.length > 0) {
            return statii
                .sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified))
                .map((r, i) => {
                    let hideButton = (r.state === 'IN_PROGRESS' || r.status === null || r.fileId === 0 || hideJsonButtons)  
                    return (<FilingStatusRow key={'filingStatus' + i}
                        submissionType={r.submissionType}
                        loading={!Boolean(r)}
                        confirmationNumber={r.status === null ? null : r.confirmationCode}
                        dateIssued={r.dashboardStatus !== "PAPERFILED" && r.status === null ? null : r.lastModified}
                        errorMessage={lang === 'en' ? r.errorMessageEn : r.errorMessageFr}
                        copyJson={hideButton ? null : () => { onCopyJsonClick(r) }}
                        isRefile={isRefile} refileIndex={refileIndex} />)
                })
        }
    }

    return (
        <div className='stackable-section'>
            <CollapsibleCardHeader icon={<ReturnStatusIcon dashboardStatus={dashboardStatus} netfileStatus={netfileStatus} />} collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)}>
                <div className='column is-8 pl-0 ml-0'>
                    {clientName === null || clientName === undefined ? <Skeleton /> :
                        <h5 className='return-status-title hnav-tabs'>
                            {clientName ?
                                <Fragment>{clientName}</Fragment> :
                                <Fragment><HrbTranslate text='ReturnInfo.Headers.ReturnStatusNoName' /> {refileIndex}</Fragment>
                            }
                        </h5>
                    }
                </div>
                <div className='column is-5'>                    
                    <ReturnStatusLabel dashboardStatus={dashboardStatus} isRefile={isRefile} refileCount={refileIndex ? refileIndex - 1 : 0} returnId={(returnStatii && returnStatii[0]) ? returnStatii[0].returnId : 0} showReturnId={true}/>                    
                </div>
            </CollapsibleCardHeader>
            <FilingStatusSummary CRAStatus={CRAStatus} RQStatus={RQStatus} T1135Status={T1135Status} collapsed={collapsed} boldText='true' />
            {!collapsed && returnStatii &&
                <Fragment>
                {renderStatiiFor('REFILECRA')}
                {renderStatiiFor('CRA')}
                {renderStatiiFor('RQ')}
                {renderStatiiFor('T1135')}
                </Fragment>
            }
        </div>
    )
}

FilingStatusCard.propTypes = {
    filer: string,
    clientName: string,
    hideJsonButtons: bool,
    returnStatii: arrayOf(object),
    isRefile: bool,
    refileIndex: number,
    isCollapsed: bool
}

export default FilingStatusCard